import { Component, Input } from '@angular/core';
import { Dayjs } from 'dayjs';

export class TrackAndTraceItem {
  stepIndex!: number;
  icon!: string;
  isError = false;
  isActive = false;
  stepDate?: Dayjs;
  messageKey?: string;
}

@Component({
  selector: 'jhi-track-and-trace-item',
  templateUrl: './track-and-trace-item.component.html',
  styleUrls: ['./track-and-trace-item.component.scss'],
})
export class TrackAndTraceItemComponent {
  @Input() trackAndTraceItem!: TrackAndTraceItem;
  @Input() savMail?: string;
  @Input() companyName = 'Your entreprise';

  getTitleKey(): string {
    return this.trackAndTraceItem.isError
      ? 'baryApp.myTransport.trackAndTrace.errorStep.step' + this.trackAndTraceItem.stepIndex + '.title'
      : 'baryApp.myTransport.trackAndTrace.step' + this.trackAndTraceItem.stepIndex + '.title';
  }

  getTextKey(): string {
    return this.trackAndTraceItem.messageKey ? this.trackAndTraceItem.messageKey : 'baryApp.myTransport.trackAndTrace.step' + this.trackAndTraceItem.stepIndex + '.text';
  }
}
